import {useContext, useEffect, useState} from 'react';
import {store} from './store.tsx';
import Chatbot from './react-chatbot-kit/src/index';
import config from './config.js';
import MessageParser from './MessageParser.js';
import ActionProvider from './ActionProvider.js';

/**
 * @typedef ChatBotContainerProps
 * @property display {boolean} - Whether to display the chatbot container.
 * @property history {AgentMessageData[]} - Conversation history.
 */

/**
 * ChatBotContainer component with display prop and fade animations.
 * @param {object} props - Component props.
 * @param {boolean} props.display - Whether to display the chatbot container.
 */
const ChatBotContainer = (props) => {
  const globalStore = useContext(store);
  // Initialize currentDisplay state with the display prop value
  const [currentDisplay, setCurrentDisplay] = useState(props.display);
  const [isVisible, setIsVisible] = useState(props.display);
  const [resetTranslateY, setRestTranslateY] = useState(false);

  useEffect(() => {
    setCurrentDisplay(props.display);
  }, [props.display]); // Listen for changes to props.display

  useEffect(() => {
    if (props.display) {
      setIsVisible(true); // Immediately make the component visible before starting fade-in
      setCurrentDisplay(true);
      const timer = setTimeout(() => {
        setRestTranslateY(true);
      }, 500); // Match this duration to your CSS transition duration
      return () => clearTimeout(timer);
    } else {
      setCurrentDisplay(false);
      setRestTranslateY(false);
      // Wait for the fade-out animation to complete before hiding the component
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 500); // Match this duration to your CSS transition duration
      return () => clearTimeout(timer);
    }
  }, [props.display]);

  return (
    <>
      <style>
        {`
            .react-chatbot-kit-chat-container {
              width: 375px !important;
              opacity: ${currentDisplay ? '1' : '0'};
              transform: ${currentDisplay ? 'translateY(60px)' : 'translateY(0)'};
              transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
              position: relative;
              z-index: 1000;
            }
            .react-chatbot-kit-chat-bot-message {
              width: auto !important;
              margin-left: 0 !important;
            }
      `}
      </style>
      <div className={`chatbot-container ${currentDisplay ? 'fade-in' : 'fade-out'}`}>
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
        />
      </div>
    </>
  );
};

export default ChatBotContainer;
